var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgElReport = function SvgElReport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 17 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1.667 2.208c0-.369.298-.667.666-.667h12a.667.667 0 0 1 .518 1.086l-2.931 3.62 2.89 3.539a.667.667 0 0 1-.516 1.088H2.334a.667.667 0 0 1-.667-.666v-8ZM3 2.874v6.667h9.89L10.543 6.67a.667.667 0 0 1-.002-.841l2.393-2.955H3Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.333 1.541c.368 0 .667.298.667.667v12a.667.667 0 0 1-1.333 0v-12c0-.369.298-.667.666-.667Z",
    clipRule: "evenodd"
  })));
};
export default SvgElReport;